import '@juitnow/api-dishtrack'
import '@juitnow/api-locations'
import '@juitnow/api-prices/admin'
import '@juitnow/api-users-v3'
import { createClient } from '@juitnow/lib-fetch-client'
import { readonly, ref } from 'vue'

import { env } from '@/init/env'

import type { Environment, User } from '@juitnow/lib-fetch-client'

/* ========================================================================== *
 * User                                                                       *
 * -------------------------------------------------------------------------- */

// The INTERNAL ref
const userRef = ref<User | null>(null)
// The EXPORTED ref (read only)
export const user = readonly(userRef)

/* ========================================================================== *
 * Client                                                                     *
 * -------------------------------------------------------------------------- */

// Our shared client instance
const environment = (env.MODE || 'development') as Environment
export const client = createClient({ environment, baseURL: env.VITE_JUIT_API_URL })
Object.defineProperty(globalThis, '$client', { value: client })

// Report errors
client.on('error', (error: any) => {
  if (error.status === 401) return // ignore unauthorized
  reportError(error)
})

// Update our user ref on user change
client.on('user', (user) => userRef.value = user)
